module.exports = __webpack_public_path__ + "img/珠海浙商总部大厦.1d24d4ad.png";